import { getSafeAxiosClient } from "@/helpers/axiosProxy";
import type { components } from '@/api/types/auto-generated';

// Bruk Swagger-genererte typer
export type SaveTemplateRequest = components['schemas']['SaveTemplateRequest'];

export interface SaveTemplateResponse {
  importDefinitionId: number;
}

export async function saveTemplateApi (request: any): Promise<SaveTemplateResponse> {
  const axiosClient = await getSafeAxiosClient();
  const response = await axiosClient.post<SaveTemplateResponse>('v2/import/save-template', request);
  return response.data;
}
